// Refactoring Code (Juan)
export const DashboardSilobagAlert: { [key: number]: { value: string } } & { null: { value: string } } = {
  0: { value: 'success' },
  1: { value: 'secondary' },
  2: { value: 'warning' },
  3: { value: 'error' },
  null: { value: 'success' },
};
